import React, { useState } from "react";
import { Button } from "@material-ui/core";
import axios from "axios";
import {
  Document,
  Page,
  Text,
  View,
  PDFDownloadLink,
} from "@react-pdf/renderer";

const styles = {
  table: {
    width: "auto",
    borderStyle: "solid",
    borderWidth: 1,
  },
  tableRow: { margin: "auto", flexDirection: "row" },
  tableCol: {
    width: "14%",
    borderStyle: "solid",
    borderWidth: 1,
    borderLeftWidth: 0,
    borderTopWidth: 0,
  },
  tableCell: { margin: "auto", marginTop: 5, fontSize: 10 },
};

export function PDF() {
  const [data, setData] = useState("");
  const [dataLoading, setDataLoading] = useState("");

  async function loadData() {
    setDataLoading(true);
    const res = await axios.get(
      "https://deborre-api.herokuapp.com/handelaars?_limit=250"
    );
    setDataLoading(false);

    const handelaars = res.data;
    handelaars.sort((h1, h2) => {
      const res = h1.gemeente.toLowerCase().localeCompare(h2.gemeente.toLowerCase());

      if (res === 0) {
        return h1.naam.toLowerCase().localeCompare(h2.naam.toLowerCase());
      } else {
        return res;
      }
    });
    setData(handelaars);
  }

  React.useEffect(() => loadData(), []);

  const PdfContent = (
    <Document>
      <Page size="A4" orientation="landscape">
        <View>
          {/* TableHeader */}
          <View style={styles.tableRow}>
            <View
              style={{
                ...styles.tableCol,
                borderTopWidth: 1,
                borderLeftWidth: 1,
              }}
            >
              <Text style={styles.tableCell}>Naam</Text>
            </View>
            <View style={{ ...styles.tableCol, borderTopWidth: 1 }}>
              <Text style={styles.tableCell}>Beschrijving</Text>
            </View>
            <View style={{ ...styles.tableCol, borderTopWidth: 1 }}>
              <Text style={styles.tableCell}>Adres</Text>
            </View>
            <View style={{ ...styles.tableCol, borderTopWidth: 1 }}>
              <Text style={styles.tableCell}>Gemeente</Text>
            </View>
            <View style={{ ...styles.tableCol, borderTopWidth: 1 }}>
              <Text style={styles.tableCell}>Email</Text>
            </View>
            <View style={{ ...styles.tableCol, borderTopWidth: 1 }}>
              <Text style={styles.tableCell}>Site</Text>
            </View>
            <View style={{ ...styles.tableCol, borderTopWidth: 1 }}>
              <Text style={styles.tableCell}>Openingsuren</Text>
            </View>
          </View>
          <View>
            {data !== "" &&
              data.map((handelaar) => {
                return (
                  <View wrap={false}>
                    <View style={styles.tableRow}>
                      <View style={{ ...styles.tableCol, borderLeftWidth: 1 }}>
                        <Text style={styles.tableCell}>{handelaar.naam}</Text>
                      </View>
                      <View style={styles.tableCol}>
                        <Text style={styles.tableCell}>
                          {handelaar.beschrijving}
                        </Text>
                      </View>
                      <View style={styles.tableCol}>
                        <Text style={styles.tableCell}>{handelaar.adres}</Text>
                      </View>
                      <View style={styles.tableCol}>
                        <Text style={styles.tableCell}>
                          {handelaar.gemeente} - {handelaar.hoofdgemeente}
                        </Text>
                      </View>
                      <View style={styles.tableCol}>
                        <Text style={styles.tableCell}>{handelaar.email}</Text>
                      </View>
                      <View style={styles.tableCol}>
                        <Text style={styles.tableCell}>{handelaar.site}</Text>
                      </View>
                      <View style={styles.tableCol}>
                        <Text style={styles.tableCell}>
                          {handelaar.openingsuren}
                        </Text>
                      </View>
                    </View>
                  </View>
                );
              })}
          </View>
        </View>
      </Page>
    </Document>
  );

  return (
    <div
      style={{
        paddingTop: 50,
        display: "flex",
        alignItems: "center",
        flexDirection: "column",
      }}
    >
      PDF overzicht van de handelaren.
      <span>Je moet wachten tot er "Download Overzicht" staat</span>
      <div style={{ width: 120, paddingTop: 50 }}>
        <Button variant="contained" color="primary">
          <PDFDownloadLink
            document={PdfContent}
            fileName="de_borre_handelaren.pdf"
            style={{ color: "white", textDecoration: "none" }}
          >
            {({ blob, url, loading, error }) =>
              loading || dataLoading
                ? "Loading document..."
                : "Download Overzicht"
            }
          </PDFDownloadLink>
        </Button>
      </div>
    </div>
  );
}
